// Widget scripts
import cardWidget from './js/widgets/cardWidget.js';
import infoCards from './js/widgets/infoCards.js';
import cardWidgetSeo from './js/widgets/cardWidgetSeo.js';
import hotButtons from './js/widgets/HotButtons.js';
import cardWidgetLogos from './js/widgets/cardWidgetLogos.js';
import sponsorWidgetContainer from './js/widgets/cssSponsors.js';

// Custom theme scripts
import './js/localjs.js';
import './js/parallax.min.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
  cardWidget();  
    infoCards();  
    cardWidgetSeo(); 
    hotButtons();
    cardWidgetLogos();
    sponsorWidgetContainer();
  });
}